module.exports = __webpack_public_path__ + "static/media/imgWrite.38d4251e.svg";